export { default } from './Panel';